// extracted by mini-css-extract-plugin
export default {"modal":"Mode_modal__SOOmG","header":"Mode_header__JaQnK","mode":"Mode_mode__icqyg","active":"Mode_active__rHo9b"};